'use client';

import React from 'react';
import TrailingLink from '@/components/atoms/TrailingLink';
import styles from './EstimationSection.module.scss';

interface EstimationSectionProps {
  title: string;
  description: string;
  ctaText?: string;
  ctaHref?: string;
  className?: string;
}

export function EstimationSection({
  title,
  description,
  ctaText = 'お見積もりを依頼する',
  ctaHref = '/contact/sales/quote',
  className
}: EstimationSectionProps) {
  return (
    <section id="estimation" className={`${styles.estimation} ${className || ''}`}>
      <h2 className={styles.sectionTitle}>{title}</h2>
      <p className={styles.estimationDescription}>{description}</p>
      <div className={styles.estimationCta}>
        <TrailingLink href={ctaHref} className={styles.ctaButton}>
          {ctaText}
        </TrailingLink>
      </div>
    </section>
  );
}

export default EstimationSection;